/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * City list
 */
export interface RegionResult { 
    /**
     * Country ISO Alpha2 code. Examples: ES, GB...
     */
    countryCode?: string;
    /**
     * Region code. Examples: Z, CU...
     */
    regionCode?: string;
    /**
     * Region name. Examples: Provincia de Zaragoza, Provincia de Cuenca...
     */
    name?: string;
}

